import React from "react";

import { TReportAdminScope } from "../reportCatalog.types";
import { ReportAutoRunProvider } from "./ReportAutoRunContext";

function getReportCodeFromPath(path: string): string {
  return path.replace("/admin/report/", "");
}

export function withReportAutoRunRoute(
  Component: React.ComponentType,
  path: string,
  scope: TReportAdminScope,
): React.ComponentType {
  const reportCode = getReportCodeFromPath(path);

  function ReportRouteWithAutoRun(props: Record<string, unknown>) {
    return (
      <ReportAutoRunProvider scope={scope} reportCode={reportCode} isDedicatedRoute>
        <Component {...props} />
      </ReportAutoRunProvider>
    );
  }

  return ReportRouteWithAutoRun;
}
